module.exports = __webpack_public_path__ + "static/media/swap-right.f01f6a4f.svg";